module.exports = __webpack_public_path__ + "media/mindwell-logo/mindwell-logo-mobile-new-a80362be.svg";